import React from 'react'

function StatisticsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M21.25 11.25L17.2058 17.3162C16.7799 17.9551 15.8228 17.8955 15.4794 17.2087L14.5206 15.2913C14.1772 14.6045 13.2201 14.5449 12.7942 15.1838L8.75 21.25"
        stroke="#393D63"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="3.75"
        y="3.75"
        width="22.5"
        height="22.5"
        rx="2"
        stroke="#393D63"
        stroke-width="2"
      />
    </svg>
  )
}

export default StatisticsIcon
